import { YhBox } from '@/components/YhBox'
import { YHModal } from "@/components/YHModal";
import { DataTable } from './DataTable'
import { PageHeader } from './PageHeader';

export const SettleDetail = ({ visible, setVisible }) => {

    const onCancel = () => {
        if (visible) {
            setVisible(false);
        }
    }

    return (
        <>
            <YHModal visible={visible} title="账单明细" showFooter={false} width={'80%'} onCancel={onCancel}>
                <YhBox title="" style={{ height: 'calc(100vh - 185px)' }}>
                    <PageHeader />
                    <br />
                    <DataTable />
                </YhBox>
            </YHModal>
        </>
    )
}
